import { kycSelectorsFactory } from 'state/secondaryMarket/shared/kyc/kyc.selector';

export const liveKycSelectors = kycSelectorsFactory('live');
